import { LoanSubmitSuccessScreen } from "@/screens/loans/setup/LoanSubmitSuccessScreen"

export default function LoanSetupSuccess() {
  return (
    <LoanSubmitSuccessScreen />
  )
}
